import { Component, OnInit, Input } from '@angular/core';
import { Assessment } from "../../shared/models/assessment";
import { DisplayCondition } from "../../shared/models/display-condition";
import { ListQuestion } from '../models/list-question';

@Component({
  selector: 'condition-edit',
  templateUrl: './condition-edit.component.html',
  styleUrls: ['./condition-edit.component.css']
})
export class ConditionEditComponent implements OnInit {

  @Input("condition") condition:DisplayCondition;
  @Input("assessment") assessment:Assessment;

  constructor() { }

  ngOnInit() {
  }

  getLabels() {
    let labels = [];
    if (this.condition && this.condition.question) {
      let question = this.condition.question;
      if (question instanceof ListQuestion) {
        labels = question.CustomLabels ? question.CustomLabels : [];
      }
      else {
        labels = this.condition.questionSet ? this.condition.questionSet.labels : [];
      }
    }
    return labels;
  }

  hasLabels() {
    return this.getLabels().length > 0;
  }

  hasQuestion() {
    return this.condition.question != null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/condition-edit/condition-edit.component.ts